
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/billofsale",
      function () {
        return require("private-next-pages/billofsale/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/billofsale"])
      });
    }
  